import Toolbar, { Item } from 'devextreme-react/toolbar';
import Button from 'devextreme-react/button';
import './Header.scss';
import type { HeaderProps } from '../../types';
import SearchPanel from '../search-panel/SearchPanel';
import { useAuth } from "../../contexts/auth";
import { CompanyTypes, InstallerType } from "../../types/enums";
import Breadcrumbs from '../breadcrumbs/Breadcrumbs';
import { useLocation, useSearchParams } from 'react-router-dom';
import Logo from '../logo/Logo';
import UserButton from '../user-button/UserButton';
import { useScreenSize } from '../../utils/media-query';
import { useNavigate } from 'react-router';
import NewMessagesButton from '../../features/common/communication/components/NewMessagesButton';
import { LtrScoreCp } from '../../features/common';
import { useGetCompany } from '../../api/company';

export default function Header({ toggleMenu, showToggleMenuButton }: HeaderProps) {
    const { user } = useAuth();

    const [params] = useSearchParams();
    const pageUrl = params.get("pageUrl");
    const location = useLocation();
    const showSearchPanel =
        user?.companyTypeId !== CompanyTypes.EEPRO &&
        !location.pathname.includes("announcement") &&
        !location.pathname.includes("gimbil") &&
        !location.pathname.includes("help");

    const company = useGetCompany(user?.companyId!);

    const showUserPanel = (user?.companyTypeId !== CompanyTypes.EEPRO);
    const showNewMessagesButton = (user?.companyTypeId === CompanyTypes.CFI);
    const showLtrScoreButton = user?.companyTypeId === CompanyTypes.CFI &&
        company.data?.installerTypes.includes(InstallerType.CFI);

    const { isLarge, isMedium } = useScreenSize();
    const isWideScreen = isLarge || isMedium;
    const navigate = useNavigate();

    return (
        <header className={'header-component'}>
            {isWideScreen &&
                <Toolbar className={'header-toolbar'}>
                    <Item location={'before'}>
                        <Logo />
                    </Item>
                    {
                        <Item
                            location={'before'}
                        >
                            {
                                showSearchPanel &&
                                <SearchPanel></SearchPanel>
                            }
                            <Breadcrumbs />
                        </Item>
                    }
                    {
                        showLtrScoreButton &&
                        <Item location={'after'}>
                            <LtrScoreCp />
                        </Item>
                    }
                    {
                        showNewMessagesButton &&
                        <Item location={'after'}>
                            <NewMessagesButton />
                        </Item>
                    }
                    {
                        showUserPanel &&
                        <Item location={'after'}>
                            <UserButton />
                        </Item>
                    }
                </Toolbar>
            }
            {!isWideScreen &&
                <Toolbar className={'header-toolbar'} multiline={false}>
                    <Item
                        location={'before'}
                    >
                        <Logo />
                        <Breadcrumbs />
                    </Item>
                    {
                        showSearchPanel &&
                        <Item
                            location={'after'}
                            widget={'dxButton'}
                            visible={true}
                        >
                            <Button icon="search" stylingMode="text" hint='Search' onClick={(e) => {
                                navigate('/search');
                            }} />
                        </Item>
                    }
                    <Item
                        location={'after'}
                        widget={'dxButton'}
                        cssClass={'menu-button'}
                        visible={showToggleMenuButton}
                    >
                        <Button icon={location.pathname === '/menu' ? 'remove' : 'menu'}
                            stylingMode="text"
                            hint={location.pathname === '/menu' ? 'Close Menu' : 'Show Menu'}
                            onClick={() => {
                                navigate(location.pathname === '/menu' ? pageUrl! :
                                    ('/menu?pageUrl=' + encodeURI(location.pathname + location.search)));
                            }} />
                    </Item>
                </Toolbar>
            }
        </header>
    )
}
